var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_9956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3898 8.70439C40.3277 3.61676 47.6723 3.61677 50.6102 8.70439L86.966 71.6637C89.9039 76.7514 86.2315 83.1109 80.3559 83.1109H7.64413C1.76844 83.1109 -1.90386 76.7514 1.03398 71.6637L37.3898 8.70439ZM47.9076 46.9985V32.0842H40.2516V46.9985C40.2516 48.5978 40.3484 50.1883 40.542 51.7701C40.7356 53.3346 40.9908 54.9338 41.3076 56.5677H46.8516C47.1684 54.9338 47.4236 53.3346 47.6172 51.7701C47.8108 50.1883 47.9076 48.5978 47.9076 46.9985ZM39.6972 64.2335C39.4684 64.7724 39.354 65.3547 39.354 65.9805C39.354 66.6063 39.4684 67.1973 39.6972 67.7535C39.9436 68.2924 40.2692 68.7617 40.674 69.1615C41.0964 69.5613 41.5892 69.8742 42.1524 70.1002C42.7156 70.3262 43.3316 70.4391 44.0004 70.4391C44.6516 70.4391 45.2588 70.3262 45.822 70.1002C46.3852 69.8742 46.878 69.5613 47.3004 69.1615C47.7228 68.7617 48.0484 68.2924 48.2772 67.7535C48.5236 67.1973 48.6468 66.6063 48.6468 65.9805C48.6468 65.3547 48.5236 64.7724 48.2772 64.2335C48.0484 63.6947 47.7228 63.2253 47.3004 62.8255C46.878 62.4257 46.3852 62.1128 45.822 61.8868C45.2588 61.6435 44.6516 61.5218 44.0004 61.5218C43.3316 61.5218 42.7156 61.6435 42.1524 61.8868C41.5892 62.1128 41.0964 62.4257 40.674 62.8255C40.2692 63.2253 39.9436 63.6947 39.6972 64.2335Z",
    fill: "#ff6633"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_9956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.d705064f1afc0c12802babdb321c5fb4.svg";
export { ForwardRef as ReactComponent };